import type { FC } from 'react';
import { Box, Container, Alert, CircularProgress } from '@mui/material';
import { useEmployeeCards } from '@pflegenavi/frontend/api-nursing-home';
import { HeaderBreadcrumbs } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';
import { MyCardsPageContent } from './components/MyCardsPageContent';

export const MyCardsPage: FC = () => {
  const { t } = useTranslation();
  const { data: cardsData, isLoading, error } = useEmployeeCards();

  return (
    <Container maxWidth={'lg'}>
      <HeaderBreadcrumbs
        heading={t('myCards.title')}
        links={[{ name: t('myCards.title') }]}
      />

      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 400,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {!!error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {t('myCards.error.loadFailed')}
        </Alert>
      )}

      {!isLoading && !error && (
        <MyCardsPageContent cards={cardsData?.data ?? []} />
      )}
    </Container>
  );
};
